import { createApp } from "vue";
import ElementPlus from "element-plus";
import App from "./App.vue";
import router from "./router";
import {setupDynamicRoutes} from "./router";
import store from "./store";
import "element-plus/dist/index.css";
import "./assets/css/index.scss";
import "./assets/icons/index.js";

import { ComponentCustomProperties } from "vue";
import { Store } from "vuex";
declare module "@vue/runtime-core" {
  interface State {
    count: number;
  }

  interface ComponentCustomProperties {
    $store: Store<State>;
  }
}

// 异步初始化应用
async function initApp() {
  const app = createApp(App);
  
  // 先配置 store 和 ElementPlus
  app.use(store);
  app.use(ElementPlus);
  
  // 加载动态路由（如果需要的话）
  try {
    await setupDynamicRoutes();
    // console.log('动态路由加载完成');
  } catch (error) {
    console.error('动态路由加载失败:', error);
  }
  
  // 配置路由
  app.use(router);
  
  // 挂载应用
  app.mount("#app");
}

// 启动应用
initApp();